export const eventTypesAll = [
  { value: "booking", text: "Booking" },
  { text: "Availability", value: "Availability" },
  { text: "Unavailable", value: "Unavailable" },
  { text: "Supervision", value: "Supervision" },
  { text: "NthQLDPHN", value: "NthQLDPHN" },
];

export const eventTypesSupervision = [
  { value: "booking", text: "Booking" },
  { text: "Availability", value: "Availability" },
  { text: "Unavailable", value: "Unavailable" },
  { text: "Supervision", value: "Supervision" },
];

export const eventTypesNthQLDPHN = [
  { value: "booking", text: "Booking" },
  { text: "Availability", value: "Availability" },
  { text: "Unavailable", value: "Unavailable" },
  { text: "NthQLDPHN", value: "NthQLDPHN" },
];

export const eventTypesNeither = [
  { value: "booking", text: "Booking" },
  { text: "Availability", value: "Availability" },
  { text: "Unavailable", value: "Unavailable" },
];

export const bookingTypes = [
  {
    value: "VIDEO",
    text: "Video",
  },
  {
    value: "PHONE",
    text: "Phone",
  },
];

export const bookingTypesNthQLDPHN = [
  {
    value: "VIDEO",
    text: "Video",
  },
  {
    value: "PHONE",
    text: "Phone",
  },
  {
    value: "FACE",
    text: "Face to Face",
  },
];

export const paymentTypes = [
  {
    value: "NDIS",
    text: "NDIS",
  },
  {
    value: "Bulk Billed",
    text: "Bulk Billed",
  },
  {
    value: "Reduced Gap",
    text: "Reduced Gap",
  },
  {
    value: "Full Fee",
    text: "Full Fee",
  },
  {
    value: "EAP",
    text: "EAP",
  },
  {
    value: "Contract",
    text: "Contract",
  },
  {
    value: "Provisional",
    text: "Provisional",
  },
  {
    text: "Transport Accident Commmission",
    value: "TAC",
  },
  {
    text: "Work Cover",
    value: "WorkCover",
  },
  {
    text: "Department of Veterans` Affairs",
    value: "DVA",
  },
  {
    text: "Island (Cocos and Christmas Islands)",
    value: "Island",
  },
];

export const eventStatuses = [
  {
    value: "Active",
    text: "Active",
  },
  {
    value: "Cancelled",
    text: "Cancelled",
  },
  {
    value: "Deleted",
    text: "Deleted",
  },
  {
    value: "NoShow",
    text: "No Show",
  },
  {
    value: "LateCancel",
    text: "Late Cancellation",
  },
  {
    value: "LateCancelProvider",
    text: "Late Cancellation by Provider",
  },
  {
    value: "Attended",
    text: "Attended",
  },
];

export const treatments = [
  {
    value: 138,
    text: "Vital sign",
  },
  {
    value: 189,
    text: "Blood test",
  },
  {
    value: 392,
    text: "Electrooculography(EOG)",
  },
  {
    value: 491,
    text: "Holter monitor(ECG)",
  },
];

export const customModelFields = {
  id: "AppointmentID",
  description: "Note",
  start: "Start",
  end: "End",
  title: "Title",
  recurrenceRule: "RecurrenceRule",
  recurrenceId: "RecurrenceID",
  recurrenceExceptions: "RecurrenceException",
};

export const bookingLocation = [
  {
    value: "Remote",
    text: "Remote",
  },
  {
    value: "Centre",
    text: "At Centre",
  },
];

export const sessionTypes = [
  {
    value: "P0102",
    text: "Psychology Therapy Session",
  },
  {
    value: "P0202",
    text: "Psychology Therapy Session",
  },
  {
    value: "P0101",
    text: "Psychology Diagnostic Assessment & Report (One-off Appt)",
  },
  {
    value: "P0201",
    text: "Psychology Diagnostic Assessment & Report (One-off Appt)",
  },
  {
    value: "P0103",
    text: "Primary	Psychology case conference",
  },
  {
    value: "P0203",
    text: "Primary	Psychology case conference",
  },
  {
    value: "P0304",
    text: "Primary Psychiatry Assessment and Report",
  },
  {
    value: "P0305",
    text: "Primary Psychiatry Follow-up Review",
  },
  {
    value: "P0306",
    text: "Primary Psychiatry Case Conference",
  },
  {
    value: "S0108",
    text: "Case Review Meeting (No Client) (SCC)",
  },
  {
    value: "S0208",
    text: "Case Review Meeting (No Client) (SCC)",
  },
  {
    value: "S0309",
    text: "Secondary Psychiatry Case Conference",
  },
];

export const sessionTypesPsychologist = [
  {
    value: "P0102",
    text: "Psychology Therapy Session",
  },
  {
    value: "P0101",
    text: "Psychology Diagnostic Assessment & Report (One-off Appt)",
  },
  {
    value: "P0103",
    text: "Primary	Psychology case conference",
  },
  {
    value: "S0108",
    text: "Case Review Meeting (No Client) (SCC)",
  },
];

export const sessionTypesClinical = [
  {
    value: "P0202",
    text: "Psychology Therapy Session",
  },
  {
    value: "P0201",
    text: "Psychology Diagnostic Assessment & Report (One-off Appt)",
  },
  {
    value: "P0203",
    text: "Primary Psychology case conference",
  },
  {
    value: "S0208",
    text: "Case Review Meeting (No Client) (SCC)",
  },
];

export const sessionTypesPsychiatrist = [
  {
    value: "P0304",
    text: "Primary Psychiatry Assessment and Report",
  },
  {
    value: "P0305",
    text: "Primary Psychiatry Follow-up Review",
  },
  {
    value: "P0306",
    text: "Primary Psychiatry Case Conference",
  },
  {
    value: "S0309",
    text: "Secondary Psychiatry Case Conference",
  },
];

export const availabilityTypes = [
  { text: "Availability", value: "Availability" },
  { text: "Unavailable", value: "Unavailable" },
  { text: "Supervision", value: "Supervision" },
  { text: "NthQLDPHN", value: "NthQLDPHN" },
];

export const clientTypes = [
  { text: "All", value: "All" },
  { text: "New", value: "New" },
  { text: "Existing", value: "Existing" },
];

export const availabilityPrograms = [
  {
    name: "Program_Medicare_General",
    label: "Medicare General",
  },
  {
    name: "Program_NDIS",
    label: "NDIS",
  },
  {
    name: "Program_CentralisedService",
    label: "Centralised Service",
  },
  {
    name: "Program_EAP",
    label: "EAP",
  },
  {
    name: "Program_Perinatal",
    label: "Perinatal",
  },
  {
    name: "Program_Group",
    label: "Group",
  },
];
